import Configurator from "./Configurator";

export default Configurator;
